<template>
  <v-dialog
    :value="opened"
    @input="onCloseDialog"
    max-width="1031px"
    scrollable
  >
    <v-card>
      <v-card-title>
        <v-container>
          <h4 class="display-1 font-weight-bold">Okruhy zájmů</h4>

          <p class="body-2 mb-4">
            Zadejte klíčové slovo pro lepší zacílení
          </p>

          <v-text-field
            v-model="query"
            clearable
            outlined
            :loading="searching"
            placeholder="Hledejte zájmy, chování nebo demografické údaje"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>

          <v-row>
            <v-col class="d-flex justify-center pa-0">
              <v-btn
                color="primary"
                :disabled="!searchBtnEnabled"
                @click="onSearchBtnClick"
              >
                Hledat
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-data-table
            :headers="headers"
            :items="foundInterests"
            item-key="id"
            class="c-data-table--alternate c-data-table--loose"
          >
            <template #item.name="{ item }">
              <div class="py-6" v-text="item.name" />
            </template>

            <template #item.audience_size="{ item }">
              {{
                item.audienceSizeLowerBound
                  ? item.audienceSizeLowerBound.toLocaleString()
                  : ""
              }}
            </template>

            <template #item.path="{ item }">
              {{ item.path ? item.path.join(" > ") : "" }}
            </template>

            <template #item.actions="{ item }">
              <template v-if="!interestIsSelected(item)">
                <v-btn @click="interestAdd(item)" text small color="navy">
                  <v-icon left>
                    mdi-plus-circle-outline
                  </v-icon>
                  Přidat
                </v-btn>
              </template>

              <template v-else>
                <v-btn @click="interestRemove(item)" text small color="navy">
                  <v-icon left>
                    mdi-minus-circle-outline
                  </v-icon>
                  Odebrat
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions class="c-dialog__footer d-block">
        <v-container v-if="selectedInterests.length > 0" class="px-6 pb-0">
          <div class="mb-4 mx-n1">
            <v-chip
              v-for="interest in selectedInterests"
              :key="interest.id"
              color="navy lighten-2"
              text-color="navy"
              class="font-weight-bold mx-1"
              close
              @click:close="interestRemove(interest)"
            >
              {{ interest.name }}
            </v-chip>
          </div>

          <v-divider />
        </v-container>

        <v-container class="d-flex justify-space-between px-6">
          <v-btn
            class="c-btn ml-auto"
            color="primary"
            text
            @click="onCloseBtnClick"
          >
            Zavřít
          </v-btn>
          <v-btn
            class="ml-auto"
            color="primary"
            :disabled="!saveBtnEnabled"
            @click="onSaveBtnClick"
          >
            Uložit
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { call, get } from "vuex-pathify"

const headers = [
  { text: "Zájem", align: "start", value: "name", sortable: false },
  { text: "Velikost publika", value: "audience_size", sortable: false },
  { text: "Cesta", value: "path", sortable: false },
  { text: "", value: "actions", sortable: false },
]

export default {
  name: "TargetingInterestsModal",
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "interests",
      validator: function(value) {
        return ["interests", "suggestions"].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      headers,
      query: null,
      selectedInterests: [],
    }
  },
  computed: {
    ...get("targeting", ["foundInterests", "searching"]),
    saveBtnEnabled() {
      return this.selectedInterests.length > 0
    },
    searchBtnEnabled() {
      return !!this.query && this.query.length > 1
    },
  },
  methods: {
    ...call("targeting", ["clearFoundInterests", "searchInterests"]),
    clearDialog() {
      this.clearFoundInterests()
      this.query = null
      this.selectedInterests = []
    },
    interestAdd(interest) {
      this.selectedInterests.push(interest)
    },
    interestIsSelected(interest) {
      return this.selectedInterests.some(i => i.id === interest.id)
    },
    interestRemove(interest) {
      this.selectedInterests = this.selectedInterests.filter(
        i => i.id !== interest.id
      )
    },
    onCloseDialog(value) {
      this.$emit("update:opened", value)
      this.clearDialog()
    },
    onCloseBtnClick() {
      this.$emit("update:opened", false)
      this.clearDialog()
    },
    onSaveBtnClick() {
      this.$emit("save", this.selectedInterests)
      this.$emit("update:opened", false)
      this.clearDialog()
    },
    onSearchBtnClick() {
      this.searchInterests(this.query)
    },
  },
}
</script>
